import React from "react";
import { FoodLogNotificationSettings } from "../../../../types";
import { PaginationHooks } from "../../../../utils/pagination";
import AthleteEngagementRow from "./EngagementRow";
import { EnableAthlete } from "./Table";
import { IAthleteEngagementRowInput } from "./utils";

interface AthleteEngagementProps {
  onClickEnableAccount: (athlete: EnableAthlete) => void;
  displaySubscribeToAthleteModal: (args: { athleteNotificationSettings: FoodLogNotificationSettings | null; athleteId: string }) => void;
  teamFoodLogNotificationSettings: FoodLogNotificationSettings | null;
  paginationHooks: PaginationHooks;
  rows: readonly IAthleteEngagementRowInput[];
  isNotemealLinked: boolean;
}

const AthleteEngagement = ({
  onClickEnableAccount,
  displaySubscribeToAthleteModal,
  teamFoodLogNotificationSettings,
  paginationHooks,
  rows,
  isNotemealLinked,
}: AthleteEngagementProps) => {
  const { limit, offset } = paginationHooks;
  const start = offset;
  const end = offset + limit;
  const renderRows = rows.filter((_, i) => i >= start && i < end);
  return (
    <>
      {renderRows.map(a => {
        const displayEnableAccount = !isNotemealLinked || a.isProfileNotemealOnly;
        return (
          <AthleteEngagementRow
            row={a}
            displaySubscribeToAthleteModal={displaySubscribeToAthleteModal}
            teamFoodLogNotificationSettings={teamFoodLogNotificationSettings}
            onClickEnableAccount={onClickEnableAccount}
            displayEnableAccount={displayEnableAccount}
          />
        );
      })}
    </>
  );
};

export default AthleteEngagement;
